export default {"src":"/_next/static/media/meetone.80e2fdc9.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};